
import restaurantIcon from "~/assets/images/business-type-restaurant.png";
import cloudKitchenIcon from "~/assets/images/multipleBrand.png";
import backButtonFullHeight from "../common/back-button-full-height.vue";

export default {
  components: { backButtonFullHeight },
  data() {
    return {
      restaurantIcon,
      cloudKitchenIcon,
      business: {},
      isMultipleBranch: "false"
    };
  },
  props: {
    businessProp: {
      type: Object,
      default: {}
    }
  },
  mounted() {
    this.business = JSON.parse(JSON.stringify(this.businessProp));
  },
  methods: {
    isRestaurant() {
      this.$emit("increment-stage", this.business);
    }
  }
};
